// extracted by mini-css-extract-plugin
module.exports = {"button":"StripeApplePayButton_button__DApR4"};